import React from "react";
import {CopyrightSharp} from "@mui/icons-material";
import {Typography} from "@mui/material";
import {B} from "../../build";
import {useStores} from "../../stores";
import {environment} from "../../env";
import {useParams} from "react-router";

export const MainFooter: React.FC = () => {
    const {p, bagStore} = useStores()
    const params = useParams();

    // const taxonomyPath = tryGeneratePath(params, "cleanup_taxonomy_builder", bagStore.bag?.id);
    // if (location.pathname === taxonomyPath && environment.package === 'sales_demo') {
    //     // Disable the footer for the taxonomy builder while CAT-3124 is not solved
    //     return <></>
    // }

    const year = new Date().getFullYear();
    return <Typography
        id="main-footer"
        className="mithra-footer"
        variant="body1"
        sx={{
            color: (theme) => theme.palette.grey[200],
            marginTop: (theme) => theme.spacing(2),
            display: 'flex',
            justifyContent: "center",
            alignItems: "center",
        }}>
        <CopyrightSharp sx={{
            fontSize: '1em',
            marginRight: '0.2em',
        }}>(c)</CopyrightSharp>
        Mithra-AI Solutions B.V. {year + ' '}
        - version: {B.APP_VERSION}
        {B.APP_ENVIRONMENT === 'demo' &&
            <>
                {/*Show the gcp project in demo environment*/}
                {' - '}
                {B.FIREBASE_PROJECT_ID}
            </>
        }
        {p.p.enableBackendStatusPage && environment.statusPageUrl &&
            <>
                {' - '}
                <a style={{marginLeft: '.3em'}} href={environment.statusPageUrl} target="_blank" rel="noreferrer">
                    service status
                </a>
            </>
        }
    </Typography>;
};
